export default __webpack_public_path__ + "static/media/pass_word_bg.56185e56.png";